import React from 'react';

import { styled } from '@mui/material/styles';

import { List, ListItem, ListItemText, IconButton, Tooltip } from '@mui/material';

import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';

const PREFIX = 'List1';

const classes = {
  list: `${PREFIX}-list`,
  list_item: `${PREFIX}-list_item`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.list}`]: {
    alignItems: 'center',
    // padding: theme.spacing(6, 1, 0, 0),
    border: 'solid 2px',
    minWidth: '25rem',
    maxWidth: '25rem',
    maxHeight: '30rem',
    minHeight: '30rem',
    overflow: 'auto',
  },

  [`& .${classes.list_item}`]: {
    paddingLeft: '5px',
    display: 'flex',
    minHeight: '2.5rem',
    borderBottom: 'solid 1px',
  }
}));

//Function that pulls the data and sends it to the Table Renderer
const List1 = props => {
    let {loading, customList, moveUp, moveDown, remove} = props;

    return (
      <Root>
        {loading ? (
          <>
          </>
        ) : (
            <List className={classes.list} key={props.customList}>
              {props.customList.map(elem => {
                return (
                  <>
                    <ListItem key={elem.id} class={classes.list_item}>
                      <ListItemText primary={elem.name} />
                      <Tooltip title="Move Up">
                        <IconButton color="none" onClick={() => moveUp(elem.id)} size="large"><ArrowUpwardIcon /></IconButton>
                      </Tooltip>
                      <Tooltip title="Move Down">
                      <IconButton color="none" onClick={() => moveDown(elem.id)} size="large"><ArrowDownwardIcon /></IconButton>
                      </Tooltip>
                      <Tooltip title="Remove from List">
                      <IconButton color="none" onClick={() => remove(elem.id)} size="large"><RemoveCircleIcon /></IconButton>
                      </Tooltip>
                    </ListItem>
                  </>
                );
              })}
            </List>
        )}
      </Root>
    );
};


export default List1;